<template>
  <div class="lmaesBanner">
    <div class="center">
      <div class="banner-overlay1">
        <span class="title">MoPaaS 大模型应用引擎RAG+Agent</span>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'LmAesBanner',
  }
</script>

<style scoped>
  .lmaesBanner {
    width: 100%;
    height: 20.83vw;
    overflow-y: hidden;
    background-image: url("../../assets/images/lmaesbanner.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
  }
  .lmaesBanner .center {
    width: auto !important;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 8vw;
  }

  .lmaesBanner .banner-overlay1 {
    color: #FFFFFF;
    text-align: left;
  }


  .lmaesBanner .banner-overlay1 .title {
    width: auto;
    font-size: 12px;
    font-weight: 500;
    color: #FFFFFF;
    display: inline-block;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/LmAesBanner.vue